import pvhApi from '@/api/pvhApi'
import PvhHeadersController from '@/controllers/PvhHeadersController'
import axios from 'axios'
import { config, url } from '@/store'

const tabs = [
  { name: 'Актуальные заказы', count: 0, id: 1, value: 'OnlyForMe' },
  { name: 'В работе', count: 0, id: 2, value: 'IsWorked' },
  { name: 'Избранные заказы', count: 0, id: 3, value: 'IsFavorites' },
  { name: 'Контроль', count: 0, id: 4, value: 'IsClosedNonChecked' },
  { name: 'Архив', id: 5, value: 'IsClosedChecked' },
  { name: 'Все', id: 6, value: '' }
]

const state = () => ({
  tableHeaders: {
    allActive: false,
    headers: PvhHeadersController.items
  },
  pvh: [],
  sort: {},
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  tabsFilter: tabs,
  activeTabIndex: 0,
  isLoading: true,
  isActiveDelete: false,
  tabLoading: false
})

const getters = {
  getPvhOrderList: state => state.pvh,
  getPvhOrderListTableHeaders: state => state.tableHeaders,
  getPvhOrderListSearchValue: state => state.searchValue,
  getPvhOrderListFilter: state => state.filter,
  getPvhOrderListPagination: state => state.pagination,
  getPvhOrderListTabsFilter: state => state.tabsFilter,
  getActiveTabIndex: state => state.activeTabIndex,
  getTabLoading: state => state.tabLoading,
  getPvhOrderListIsActiveDelete: state => state.isActiveDelete,
  getPvhOrderListIsLoading: state => state.isLoading
}

const mutations = {
  SET_TAB_LOADING: (state) => {
    state.tabLoading = !state.tabLoading
  },
  SET_PVH_TABLE_HEADERS: (state, headers) => {
    state.tableHeaders.headers = headers
  },
  GET_PVH_LIST: (state, pvh) => {
    state.isActiveDelete = false
    state.tableHeaders.allActive = false

    if (!(pvh instanceof Array) && pvh?.list) {
      state.pvh = pvh.list
      return
    }

    state.isLoading = true
    state.pvh = pvh.map(item => {
      const customLabel = `${item?.client?.surname || ''} ${item?.client
        ?.name || ''} ${item?.client?.patronymic || ''}`.trim()
      const { profile } = item.creator
      const creatorName =
        profile?.full_name ||
        `${profile?.surname || ''} ${profile?.name ||
          ''} ${profile?.patronymic || ''}`.trim()

      return {
        ...item,
        status: item.status?.name,
        gauger: item.gauger?.profile?.full_name,
        client: {
          name: customLabel,
          telephone: item.client?.phone,
          address: item.client?.address
        },
        installer: item.installer?.profile?.full_name,
        deliveryMethod: item.delivery?.name,
        order_type: item.order_type?.name,
        creator: creatorName,
        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  TOGGLE_PVH_LIST_ITEM_CONTROLS: (state, itemId) => {
    state.pvh.forEach(elem => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  TOGGLE_PVH_LIST_ITEM_ACTIVE: (state, itemId) => {
    const itemsLength = state.pvh.length
    let counter = 0

    state.pvh.forEach(elem => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0
      ? (state.isActiveDelete = true)
      : (state.isActiveDelete = false)

    state.tableHeaders.allActive = counter === itemsLength
  },
  TOGGLE_PVH_LIST_ITEM_ACTIVE_ALL: state => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.pvh.forEach(elem => {
      elem.isActive = state.tableHeaders.allActive
    })
    state.isActiveDelete = state.tableHeaders.allActive
  },

  // pagination
  SET_PVH_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  RESET_PVH_LIST_CURRENT_PAGE: state => {
    state.pagination.currentPage = 1
  },
  SET_CURRENT_PAGE: (state, pageNum) => {
    state.pagination.currentPage = pageNum
  },

  // search
  SET_PVH_LIST_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // sort
  SET_PVH_LIST_SORT: (state, sortOptions) => {
    state.sort = sortOptions
  },

  // filter
  TOGGLE_PVH_LIST_FILTER: state => {
    state.filter.active = !state.filter.active
  },

  // tabsFilter
  SET_PVH_LIST_TABS_ACTIVE_INDEX: (state, index) => {
    state.activeTabIndex = index
  },
  SET_PVH_LIST_TABS_COUNT: (state, countInfo) => {
    state.tabsFilter = state.tabsFilter.map(tab => {
      switch (tab.value) {
        case 'OnlyForMe':
          tab.count = countInfo.actual_count
          break
        case 'IsWorked':
          tab.count = countInfo.in_work_count
          break
        case 'IsFavorites':
          tab.count = countInfo.favorites_count
          break
        case 'IsClosedNonChecked':
          tab.count = countInfo.control_count
          break
      }

      return tab
    })
  },
  RESET_PVH_LIST_STORE: (state) => {
    // state.searchValue = ''
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.pagination.currentPage = 1
  }
}

const actions = {
  setTableHeaders ({ state, commit }, index) {
    const headers = state.tableHeaders.headers.map((header, i) => {
      if (i === index) {
        return {
          ...header,
          shown: !header.shown
        }
      }
      return header
    })
    PvhHeadersController.items = headers
    commit('SET_PVH_TABLE_HEADERS', headers)
  },

  getPvh ({ commit, state }) {
    const tabFilter = state.tabsFilter[state.activeTabIndex].value
    const search = `search[${tabFilter}]`

    const params = {
      expand: 'status,delivery,client,gauger,order_type,installer,creator,comments',
      sort: (state.sort.descending ? '-' : '') + (state.sort.name || 'id'),
      take: state.pagination.currentTake,
      page: state.pagination.currentPage,
      'search[all]': state.searchValue ? `${state.searchValue}` : ''
    }

    commit('SET_TAB_LOADING')
    axios.get(`${url}/pvc?${search}`, { params, ...config })
      .then(response => {
        const countInfo = response.data.data.at(-1)
        const list = response.data.data.slice(0, -1)

        commit('SET_PVH_LIST_TABS_COUNT', countInfo)
        commit('GET_PVH_LIST', list)
        commit('SET_PVH_LIST_PAGINATION', response.headers)
      })
      .catch(error => {
        console.log('Ошибка получения списка клиентов', error.response)
      }).finally(() => commit('SET_TAB_LOADING'))
  },
  togglePvhOrderListItemControls ({ commit }, itemId) {
    commit('TOGGLE_PVH_LIST_ITEM_CONTROLS', itemId)
  },
  togglePvhOrderListItemActive ({ commit }, itemId) {
    commit('TOGGLE_PVH_LIST_ITEM_ACTIVE', itemId)
  },
  togglePvhOrderListItemActiveAll ({ commit }) {
    commit('TOGGLE_PVH_LIST_ITEM_ACTIVE_ALL')
  },

  // pagination
  getPvhOrderListPage ({ commit }, pageNum) {
    commit('SET_CURRENT_PAGE', pageNum)
    this.dispatch('getPvh')
  },

  // search
  setPvhOrderListSearchValue ({ commit }, searchValue) {
    commit('SET_PVH_LIST_SEARCH_VALUE', searchValue)
    commit('RESET_PVH_LIST_CURRENT_PAGE')
    this.dispatch('getPvh')
  },

  // sort
  getPvhSort ({ commit, dispatch }, sort) {
    commit('SET_PVH_LIST_SORT', sort)
    dispatch('getPvh')
  },

  async removePvh ({ state, dispatch, commit }, electOnly = false) {
    const allIds = state.pvh.filter(e => {
      if (e.isActive) {
        return e
      }
    }).map(({ id }) => id)

    try {
      await pvhApi.deleteOrderFromElect(allIds)
    } catch {}

    if (!electOnly) {
      for (let index = 0; index < allIds.length; index++) {
        await pvhApi.deleteOrderList(allIds[index])
      }
    }

    dispatch('getPvh')
  },

  async addPvhToElect ({ commit, dispatch }, ids) {
    await pvhApi.addOrderToElect(ids)
    dispatch('setPvhOrderListActiveTabs', 2)
  },

  // tabsFilter
  setPvhOrderListActiveTabs ({ commit, dispatch }, index) {
    commit('SET_PVH_LIST_TABS_ACTIVE_INDEX', index)
    dispatch('getPvh')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
